import { Component, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'pioneer-reservation-page',
  templateUrl: './reservation-page.component.html'
})
export class ReservationPageComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  constructor(private eventStore: EventStore,
              private reservationCompareStore: ReservationCompareStore) {
  }

  ngOnInit() {
    this.eventStore.selectedEvent.subscribe(event => {
      this.onyxEvent = new OnyxEvent(event);
    });
  }

  getSummarySelected(): Observable<boolean> {
    return this.reservationCompareStore.getShowReservationSummary();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/reservations/reservation-page/reservation-page.component.ts